import React, { useState } from 'react';

import useModal from '../../../../../hooks/useModal';
import { useMission2 } from './useMission2';

import MissionResultToast from '../missionResultToast';
import SearchInput from './searchInput';
import Mission2Quiz from './mission2Quiz/';

import Mission2Text from '../asset/11-mission2-Text.png';
import Mission2Img from '../asset/12-mission2-Img.png';
import Mission2OtherReason from '../asset/14-mission2-other-reason.png';
import Mission2BtnSubmit from '../asset/15-mission2-btn-submit.png';
import Mission2BtnComplete from '../asset/16-mission2-btn-complete.png';
import Mission2FinalTerms from '../asset/17-mission2-final-terms.png';
import Mission2Success from '../asset/18-mission2-success.png';

import { BGWrap } from '../styled';

import { 
  OtherReasonWrap,
  AreaWrap, 
  TextImg,
  Textarea,
  SubmitWrap, 
  SubmitImg,  
} from './styled';

const Mission2Component = ({
  mission1Count,
  ableMission2,
  updateAbleMisssionState,
  isValidAuth,
}) => {
  const { openModal, ModalPortal, closeModal } = useModal();

  const {
    checkMission2Condition,
    selectMyAddress,
    onClickItem,
    onChangeOtherReason,
    onFocusHandler,
    submitMission2,
  } = useMission2(mission1Count, updateAbleMisssionState, isValidAuth, openModal)

  const getSubmitBtnType = key => {
    switch (key) {
      case false:
        return Mission2BtnSubmit
      
      case true:
        return Mission2BtnComplete

      default:
        return Mission2BtnComplete
    }
  }
  
  return (
    <>
      <BGWrap width={710} height={355} imgUrl={Mission2Text} />

      <BGWrap width={710} height={450} imgUrl={Mission2Img} />

      <SearchInput 
        selectMyAddress={selectMyAddress} 
        myAddress={checkMission2Condition.myAddress} 
        mission1Count={mission1Count}
        isValidAuth={isValidAuth}
      />
      
      <Mission2Quiz 
        selectedResult={checkMission2Condition.selectedResult} 
        onClickItem={onClickItem}
      />
      
      <OtherReasonWrap>
        <AreaWrap>
          <TextImg imgUrl={Mission2OtherReason} />
        </AreaWrap>

        <Textarea>
          <textarea 
            value={checkMission2Condition.hasOtherReason} 
            placeholder={'예) 동네 분위기가 좋아요.'} 
            onChange={onChangeOtherReason.bind(null)} 
            onFocus={onFocusHandler} 
          />
          <div>{checkMission2Condition.hasOtherReason?.length} / 800</div>
        </Textarea> 
      </OtherReasonWrap>

      <SubmitWrap>
        <SubmitImg 
          imgUrl={getSubmitBtnType(ableMission2)}     
          onClick={submitMission2.bind(null, ableMission2)}
        />
      </SubmitWrap>

      <ModalPortal>
        <MissionResultToast 
          closeModal={closeModal} 
          missionResultImg={Mission2Success}
          type="mission2"
        />
      </ModalPortal>
      
      <BGWrap width={710} height={1450} imgUrl={Mission2FinalTerms} />
    </>
  )
}

export default Mission2Component;
